import { getCustomBadges } from '@app/ducks/helpers';
import { Badges, Product } from '@typings';
import { omit } from 'ramda';

import { useProductPriceComponents } from './useProductPriceComponents';

interface Props {
  variant: Product.Standard;
}

export const useLookbookProductBadges = ({ variant }: Props) => {
  const { isOnSale } = useProductPriceComponents(variant);
  const shouldShowAsNew = variant.showAsNew ?? false;
  const saleBadge = {
    badgeType: 'sale' as const,
    isVisible: isOnSale,
  };

  const newBadge = {
    badgeType: 'new' as const,
    isVisible: shouldShowAsNew,
  };

  const defaultBadges: Badges.DefaultBadge[] = [saleBadge, newBadge].filter(({ isVisible }) => isVisible).map(omit(['isVisible']));

  const customBadges = getCustomBadges(variant);
  const badgesCount = defaultBadges.length + customBadges.length;

  return {
    badgesCount,
    customBadges,
    defaultBadges,
  };
};
